import { render, staticRenderFns } from "./ExpenseCategory.vue?vue&type=template&id=4cd630e6&"
import script from "./ExpenseCategory.vue?vue&type=script&lang=ts&"
export * from "./ExpenseCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports